import React, { useContext, useEffect, useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';

import PaymentContext from '../PaymentContext';
import NovattiPayment from '../novatti-ui/novatti-payment';
import TillPayment from '../till-payments-ui/TillPayment';
import { PAYMENT_PROCESSORS } from '../paymentHelpers';
import { getPaymentGatewayStatus } from './gatewayStatus';
import { GATEWAY_STATUS } from '../../../utils/constants';

const { NOVATTI, TILL } = PAYMENT_PROCESSORS;

const PaymentProcessorContainer = () => {
  const { showPaymentMethods, paymentProcessor, scriptMode } = useContext(PaymentContext);
  const [gatewayStatus, setGatewayStatus] = useState({
    status: GATEWAY_STATUS.ONLINE,
  });

  useEffect(() => {
    const loadGatewayStatus = async () => {
      const status = await getPaymentGatewayStatus();
      setGatewayStatus(status);
    };

    loadGatewayStatus();
  }, []);

  // Remove if the script admin fee will be reimplemented
  if (scriptMode) {
    return null;
  }

  if (!showPaymentMethods) {
    return null;
  }

  // If the gateway is in maintenance or offline mode, show a message instead of the payment processor
  if (gatewayStatus.status !== GATEWAY_STATUS.ONLINE) {
    return (
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
        sx={{
          margin: '5px auto',
          padding: '20px',
        }}
      >
        <Box
          sx={{
            border: '1px solid #d32f2f',
            backgroundColor: '#ffebee',
            borderRadius: '8px',
            padding: '16px',
            maxWidth: '600px',
            margin: '16px auto',
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" color="error" gutterBottom>
            Payment System {gatewayStatus.status === GATEWAY_STATUS.MAINTENANCE ? 'Under Maintenance' : 'Unavailable'}
          </Typography>
          <Typography variant="body1">
            {gatewayStatus.message || 'Our payment system is currently unavailable. Please try again later.'}
          </Typography>
          {gatewayStatus.estimatedDowntimeUntil && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Estimated to be back online by: {gatewayStatus.estimatedDowntimeUntil}
            </Typography>
          )}
        </Box>
      </Grid>
    );
  }

  return (
    <Grid
      size={{
        xs: 12,
        md: 6,
      }}
      sx={{
        margin: '5px auto',
      }}
    >
      {paymentProcessor === NOVATTI && <NovattiPayment />}
      {paymentProcessor === TILL && <TillPayment />}
    </Grid>
  );
};

export default PaymentProcessorContainer;
